// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of CraneHVACC
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## CraneHVACC Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.CraneHVACC.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## CraneHVACC Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.CraneHVACC.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CraneHVACC Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.CraneHVACC.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CraneHVACC Update
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.CraneHVACC.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CraneHVACC Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.CraneHVACC.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CraneHVACC Calculate
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Calculate = async (form, option) => {
  const response = await $api.post(
    Endpoints.CraneHVACC.Calculate(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CraneHVACC GetCraneParameters
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetCraneParameters = async (option) => {
  const response = await $api.get(
    Endpoints.CraneHVACC.GetCraneParameters(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  Calculate,
  GetCraneParameters,
};
